import React, { memo, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ArrowForward, Delete, Star } from '@mui/icons-material';
import { styled as muiStyled } from '@mui/material/styles';
import Acent from 'components/Acent';

import COLOR from 'utils/constants/color';
import CustomDateTimePicker from 'components/DateTimePicker';
import Loading from 'components/Loading';
import SentryWrap from 'components/Sentry';
import {Snackbar , Alert, Switch} from '@mui/material';
import Tag from 'components/Tag';
import moment from 'moment';
import styled from 'styled-components';
import useMobileDeviceDetection from 'containers/chat/hooks';
import { Col, Drawer, Row } from 'antd';
import { useAlert } from "components/UI/alertSakeBar/alertProvider";
import { GRADE_TYPE_ALL, GRADE_TYPE_CANVAS } from 'utils/config/reference';
import { GrammarDrillCover } from 'utils/assets/images';
import { filter, find, get, isEmpty, isPlainObject, map } from "lodash";
import { getCurrentSemStartAndEndDate, isAfterTime, isBeforTime } from 'utils/methods/math';
import { useParentOrgId } from 'store/organizations/selectors';
import { handleCreateWorksheetAssignment, handleUpdateWorksheetAssignment } from 'store/activities/thunks';
import { handleCloneWorksheet, handleGetWorksheetAssignedClassIds, handleListWorkSheet } from 'store/worksheet/thunks';
import { handleDeleteCanvasAssignment } from "store/canvas/thunks";
import { handleDeleteGoogleAssignment } from 'store/googleClassRoom/thunks';
import { handleDeleteSchoologyAssignment } from 'store/schoology/thunks';
import { handledeleteDebate } from 'store/debate/thunks';
import { useClassGameActivity } from 'store/one_game/selectors';
import { useClassUsers, useUserClasses, useUsersByClass } from 'store/userClasses/selectors';
import { useCollectionNotification } from 'utils/methods/firebaseNotification';
import { useCurrentClass } from 'store/classes/selectors';
import { useCurrentUser } from 'store/users/selectors';
import { useSchoologyAssignment, useSchoologyGradeCategory } from "store/schoologyauth/selectors";
import { v4 } from 'uuid';
import WorksheetAssignmentClassConfig from './ClassConfig';
import customEditSvg from '../../../utils/assets/images/customEdit.svg';
import { useIsTab, useMobileDetect } from "containers/chat/hooks";

//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import {
    Button,
    Checkbox,
    FormControl,
    FormControlLabel,
    InputLabel,
    ListItemText,
    MenuItem,
    Modal,
    Select,
    TextField
} from '@mui/material';
import useCurrentAssignment from 'components/hooks/assignment/useCurrentAssignment';
import { handleLearningModuleCount } from 'store/bingo/thunks';
import { useUI } from 'store/UI/selectors';
import { useGetMaskId } from 'components/hooks/maskId/useGetMaskId';
import { usePageCover } from 'components/hooks/pageCover/pageCover';

const StyledFormControl = muiStyled(FormControl)(({ theme }) => ({
    marginBottom: '25px',
    width: '300px',
    '&.rootDif': {
        width: '200px'
    },
    '&.rootDifFull': {
        width: "fit-content"
    },
    '&.formControlStudent': {
        backgroundColor: "#fff"
    },
    '&.formControl': {
        margin: '2px',
        width: "100%",
        minWidth: 120
    },
    '&.dropdownSwitch': {
        margin: '2px',
        maxWidth: 250,
        minWidth: 120
    }
}));

const StyledSwitch = muiStyled(Switch)({
    '&.MuiSwitch-sizeSmall': {
        width: '40px',
        height: '25px'
    },
    '& .Mui-checked': {
        transform: 'translateX(17px) !important'
    }
});

const StyledLabel = muiStyled('span')({
    textTransform: 'uppercase'
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
    getContentAnchorEl: () => null,
};

const StyledFormControlLabel = muiStyled(FormControlLabel)({
    '&.MuiFormControlLabel-root': {
        marginBottom: '25px',
        width: '300px'
    },
    '&.rootDif': {
        width: '200px'
    },
    '&.rootDifFull': {
        width: "fit-content"
    }
});

const StyledCheckbox = muiStyled(Checkbox)({
    '&.Mui-checked': {
        color: `${COLOR.green}!important`
    }
});

const StyledSelect = muiStyled(Select)({
    '& .MuiChip-root': {
        margin: 2
    }
});

const StyledListItemText = muiStyled(ListItemText)({
    '&.primary': {
        color: COLOR.green
    }
});

const StyledInputLabel = muiStyled(InputLabel)({
    textTransform: 'uppercase'
});

//  -- Components ---------------------

//  -- Constants ----------------------

//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------
const Container = styled.div`
    border-top: 1px solid ${COLOR.black700};
    margin-top: 24px;
    padding-top: 40px;
    width: 100%;
`;

const Description = styled.span`
    color: ${COLOR.black300};
    display: block;
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
    margin-bottom: 48px;
`;

const Header = styled.span`
    color: ${COLOR.black100};
    font-size: 28px;
    font-weight: 600;
    line-height: 28px;
    margin-bottom: 16px;
`;

const Note = styled.span`
    color: ${COLOR.black400};
    display: block;
    font-size: 13px;
    font-weight: 400;
    line-height: 20px;
    margin-bottom: 16px;
`;

const Wrapper = styled.form`
    margin: 0px auto;
    width: 100%;
    position: relative;
    top: 0px; 
    padding-bottom: 50px;
`;


const ModalContent = styled.div`
    align-items: center;
    background-color: ${COLOR.white};
    border-radius: 3px;
    display: inline-flex;
    flex-direction: column;
    left: 50%;
    max-width: 320px;
    padding: 16px;
    position: absolute;
    text-align: center;
    top: 50%;
    transform: translate(-50%, -50%);
`;

const ModalRow = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 16px;
    width: 100%;
`;
const Image = styled.img`
    background-color: ${COLOR.white};
    box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
    height: auto;
    width: 100%;
`;

const ImageContiner = styled.div`
    background-color: transparent;
    border: none;
    flex: 1;
    outline: none;
    width: 100%;
    height:100%;
    margin-right: 16px;
    padding-right: 10px;

    @media screen and (max-width: 576px){
        padding-right: 0px;
    }
        @media screen and (max-width: 1366px){
            display:none;
        }
`;
const StartPractice = styled.button`
  background-color: #5e2ca5;
  color: white;
  font-size: 16px;
  font-weight: bold;
  // font-family: "Georgia", serif;
  padding: 6px 14px;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  outline: none;
  transition: background 0.3s ease, transform 0.2s;
  &:hover {
    background-color: #4a1f8a;
  }
    @media Screen and (max-width: 600px){
      font-size:12px;
      font-weight: 600;
      line-height:normal;
    }
    @media Screen and (min-width:809px) and (max-width: 1200px){
      font-size:10px;
    }
`;

const ActivityFormWorksheet = ({
    from,
    chapter,
    workSheetInfo,
    page,
    assignmentInfo,
    onDisplayNameChange
}) => {
    const deviceType = useMobileDeviceDetection();
    const dispatch = useDispatch();
    const isTablate = useIsTab();
    const currentClass = useCurrentClass()
    const currentUser  = useCurrentUser()
    const classUsers = useClassUsers();
    const userClasses = useUserClasses()
    const usersByClass = useUsersByClass();
    const { createCollectionNotification, createNotificationAssignment } = useCollectionNotification();
    const [dataLoading, setDataLoading] = React.useState(false);
    const [submissionLoading, setSubmissionLoading] = React.useState(false);
    const [initialDueDate, setInitialDueDate] = useState(null)
    const [initialLateDate, setInitialLateDate] = useState(null)
    const [deleteClassAssignedActivityToggle, setdeleteClassAssignedActivityToggle] = React.useState(false);
    const [schoologyGradeCategory, , schoologyAllClassGradeCategory] = useSchoologyGradeCategory()
    const isSchoologyUser = currentUser && currentUser.schoologyid ? true : false;
    const isCanvas_user = currentUser && currentUser.canvas_id;
    const isGoogleUser = currentUser && currentUser.googleId;
    const [initialData, setInitialData] = useState(null)
    const [, listSchoologyAssignment] = useSchoologyAssignment()
    const parentOrgId = useParentOrgId();
    const currentSemDateAndTime = getCurrentSemStartAndEndDate(parentOrgId)
    const [openAlert, setAlert] = React.useState({ open: false, message: "" });
    const filterClassUsers = filter(classUsers, (user) => user?.role !== 'teacher' && user?.active === true).map(user => user.id);
    const { class_game_activity, fetchClassGameActivity } = useClassGameActivity();
    const { grammer_drill_assigned_class = [] } = useUI();
    const [activityDrawer,setActivityDrawer] = useState(false)
    const [alreadyAssignedClassIds, setAlreadyAssignedClassIds] = useState([]);
    const {maskId} = useGetMaskId(from, page, chapter);
    const pageCover = usePageCover({ assignmentData: workSheetInfo });
   
    useEffect(() => {
        const loadAssignedClassIds = () => {
            if (!activityDrawer) {
                return;
            }
            const assignedEntry = Array.isArray(grammer_drill_assigned_class)
                ? grammer_drill_assigned_class.find((item) => String(item?.worksheet_id ?? item?.id) === String(workSheetInfo?.id))
                : null;
            const classIds = assignedEntry?.class_ids || assignedEntry?.classIds || [];
            setAlreadyAssignedClassIds(
                Array.isArray(classIds) ? classIds.map((id) => String(id)) : []
            );
        };
        loadAssignedClassIds();
    }, [workSheetInfo?.id, activityDrawer, grammer_drill_assigned_class]);

    const prevData = useRef()
    const lastSyncedAssignmentKeyRef = useRef(null)
    const wasDrawerOpenRef = useRef(false)
    const assignmentSyncKey = useMemo(() => {
        if (!assignmentInfo) return 'none'
        if (isPlainObject(assignmentInfo) && isEmpty(assignmentInfo)) {
            return `empty:${workSheetInfo?.id ?? ''}:${chapter}:${page}`
        }
        const aid = get(assignmentInfo, 'id')
        return aid != null && aid !== '' ? `id:${aid}` : `empty:${workSheetInfo?.id ?? ''}:${chapter}:${page}`
    }, [assignmentInfo, workSheetInfo?.id, chapter, page])
    const isEditing = useMemo(()=>get(assignmentInfo, "id", false),[assignmentInfo])

    const [assignmentData, setAssignmentData] = useState({
        dueDate: '',
        scheduleAt: '',
        classes: [],
        weightage:100,
        max_point:100,
        grade_type:"percent",
        ungraded:false,
        display_name: workSheetInfo?.displayName,
        grade_for_participation:true
    })
    const dispNameRef = useRef();
    const showAlert = useAlert();
    const  {checkAssignmentHaveSubmission} = useCurrentAssignment(assignmentInfo.id);

    useEffect(() => {
        const openedNow = activityDrawer && !wasDrawerOpenRef.current;
        wasDrawerOpenRef.current = activityDrawer;

        if (assignmentInfo) {
            if (lastSyncedAssignmentKeyRef.current === assignmentSyncKey && !openedNow) {
                prevData.current = assignmentInfo
                return
            }
            let dueDate = get(assignmentInfo, "dueDate")
            let scheduleAt = get(assignmentInfo, "scheduleAt")
            if (isPlainObject(assignmentInfo) && isEmpty(assignmentInfo)) {
                const defaultDisplayName = assignmentInfo?.displayName || workSheetInfo?.displayName;
                if (onDisplayNameChange && defaultDisplayName) {
                    onDisplayNameChange(defaultDisplayName);
                }
                setAssignmentData({
                    dueDate: '',
                    scheduleAt: '',
                    classes: [],
                    weightage: 100,
                    max_point: 100,
                    grade_type: "percent",
                    ungraded: false,
                    display_name: defaultDisplayName,
                    grade_for_participation: true
                })
            } else {
                setAssignmentData(assignmentInfo)
            }

            const todayDtime = moment().toISOString();
            const scheduleMoment = scheduleAt ? moment(scheduleAt) : moment(todayDtime);
            const defaultDueDate = scheduleMoment
                .clone()
                .set({ hour: 23, minute: 59, second: 59, millisecond: 0 })
                .toISOString();
            if (!dueDate) {
                dueDate = defaultDueDate;
            }
            if (!scheduleAt) {
                scheduleAt = todayDtime;
            }
            setAssignmentData(e => {
                const newDisplayName = assignmentInfo.displayName || workSheetInfo?.displayName;
                return {
                    ...e,
                    scheduleAt,
                    dueDate,
                    display_name: newDisplayName
                }
            })
            const newDisplayName = assignmentInfo.displayName || workSheetInfo?.displayName;
            if (onDisplayNameChange && newDisplayName) {
                onDisplayNameChange(newDisplayName);
            }
            if (currentClass && get(assignmentInfo, "classes", [])?.length == 0) {
                setAssignmentData(e => {
                    return ({
                        ...e,
                        classes: [{
                            displayName: `${currentClass.displayName} (${currentClass.code})`,
                            id: currentClass.id,
                            dueDate: dueDate,
                            scheduleAt: scheduleAt,
                            sectionId: currentClass.sectionId,
                            schoologyCategory: assignmentInfo?.schoologyCategory || '',
                        }]
                    })
                })
            }
            if (assignmentInfo) {
                if (!initialData || get(initialData, "id") !== get(assignmentInfo, "id")) {
                    setInitialData(assignmentInfo)
                }
                if (get(prevData.current, "id") === get(assignmentInfo, "id")) {
                    if (!initialDueDate) {
                        setInitialDueDate(get(assignmentInfo, "dueDate"))
                    }
                    if (!initialLateDate) {
                        if (isBeforTime(get(assignmentInfo, "lateDate"), get(assignmentInfo, "dueDate"))) {
                            setInitialLateDate(null)

                        } else {
                            setInitialLateDate(get(assignmentInfo, "lateDate"))
                        }
                    }

                } else {
                    setInitialDueDate(get(assignmentInfo, "dueDate"))
                    setInitialLateDate(get(assignmentInfo, "lateDate"))
                }

            } else {
                setInitialData(null)
                setInitialDueDate(null)
                setInitialLateDate(null)
            }
            lastSyncedAssignmentKeyRef.current = assignmentSyncKey
        } else {
            lastSyncedAssignmentKeyRef.current = null
            const defaultDisplayName = assignmentInfo?.displayName || workSheetInfo?.displayName;
            if (onDisplayNameChange && defaultDisplayName) {
                onDisplayNameChange(defaultDisplayName);
            }
            setAssignmentData(e => ({
                ...e,
                display_name: defaultDisplayName
            }))
        }
        prevData.current = assignmentInfo
    }, [assignmentInfo, assignmentSyncKey, activityDrawer, chapter, currentClass, onDisplayNameChange, page, workSheetInfo])

    const onSubmit = async (e) => {
        e.preventDefault();
        setSubmissionLoading(true);
        try {
            
            let worksheetToAssign = workSheetInfo;
            worksheetToAssign.book_id = workSheetInfo?.chapter;
            worksheetToAssign.display_name = workSheetInfo.displayName;
            worksheetToAssign.page_id = workSheetInfo.page;
            const isShared = workSheetInfo?.user_id !== currentUser?.id && 
                           Array.isArray(workSheetInfo?.share_list) && 
                           workSheetInfo?.share_list?.includes(currentUser?.id);

            const isAlreadyClone = workSheetInfo?.user_id === currentUser?.id && workSheetInfo?.shared_by;

            if (!isEditing && isShared && !isAlreadyClone) {
                const originalWorksheetId = workSheetInfo?.shared_by || workSheetInfo.id;
                
                const cloneResponse = await dispatch(
                    handleCloneWorksheet({
                        worksheet_id: originalWorksheetId,
                        user_id: currentUser.id,
                        display_name: assignmentData.display_name || workSheetInfo.displayName,
                    })
                );

                if (cloneResponse?.success && cloneResponse?.data?.id) {
                    worksheetToAssign = {
                        ...workSheetInfo,
                        id: cloneResponse.data.id,
                        user_id: currentUser.id,
                        display_name: cloneResponse.data.display_name,
                    };
                } else {
                    showAlert(cloneResponse?.error || "Failed to clone worksheet", "error");
                    setSubmissionLoading(false);
                    return;
                }
            }   
            const book_info = {
                locate_url: window.location.pathname + window.location.search,
                mask_id: maskId,
                page_cover_url: GrammarDrillCover,
            }
            let notificationData = {
                id: v4(),
                classId: get(currentClass, "id", ""),
                displayName: get(assignmentData, "display_name", ""),
                senderId: get(currentUser, 'id', ''),
                receiversId: filterClassUsers,
                modified: moment().toISOString(),
                data: {
                    chapter: chapter,
                    page: page,
                    id: get(worksheetToAssign, "id", ""),
                    assignmentType: 'worksheet',
                    meta_data: {
                        book_info: book_info
                    }
                },
                message: `Your teacher Assign this Grammar Drill`,
                type: "create_activity",
                userSeen: [],
            };
            if (!isEditing) {
                worksheetToAssign.meta_data = {
                    book_info: book_info
                }
                const respone = await dispatch(handleCreateWorksheetAssignment(worksheetToAssign, assignmentData, currentUser.id))
                if (respone && respone.length > 0) {
                    await dispatch(
                        handleListWorkSheet(chapter, currentUser.role, currentUser.id, null, null, null, null, currentClass?.id)
                    );
                    sendNotifications(notificationData, get(assignmentData, "classes", []));
                    showAlert(`Assigned successfully`, "success")
                    fetchClassGameActivity()
                    closeAssignScreen()
                } else {
                    showAlert(`Something went wrong`, "error")
                }
            } else {
                notificationData.message = `Your teacher Updated this Grammar Drill`;
                notificationData.type = "update_activity";
                notificationData.data.meta_data = {
                    book_info: book_info
                }
                const respone = await dispatch(handleUpdateWorksheetAssignment(assignmentData, currentUser.id,assignmentInfo.id))
                if (respone && respone.length > 0) {
                    await dispatch(
                        handleListWorkSheet(chapter, currentUser.role, currentUser.id, null, null, null, null, currentClass?.id)
                    );
                    sendNotifications(notificationData, get(assignmentData, "classes", []));
                    showAlert(`Assigned successfully`, "success")
                    fetchClassGameActivity()
                    closeAssignScreen()
                } else {
                    showAlert(`Something went wrong`, "error")
                }
            }
            await dispatch(handleGetWorksheetAssignedClassIds(currentUser.id, chapter));
            dispatch(handleLearningModuleCount({
                chapter: chapter,
                userId: currentUser.id,
                pageId: page,
            }));
        } catch (error) {
            console.log(error, "error in creating worksheet as assignment")
        } finally {
            setSubmissionLoading(false);
        }
    };


    const sendNotifications = async (notificationData, selectedClasses = []) => {
        try {
            const classesToNotify = Array.isArray(selectedClasses) && selectedClasses.length > 0
                ? selectedClasses
                : [{ id: get(currentClass, 'id', '') }];
            const classesForNotification = classesToNotify
                .filter((cls) => cls?.id)
                .map((cls) => ({
                    id: cls.id,
                    users: Array.isArray(cls?.users) && cls.users.length > 0 ? cls.users : null,
                }));
                const book_info = {
                    locate_url: window.location.pathname + window.location.search,
                    mask_id: maskId,
                    page_cover_url: GrammarDrillCover,
                }
            const payload = {
                ...notificationData,
                data: {
                    ...(notificationData?.data || {}),
                    classes: classesForNotification,
                    meta_data: {
                        book_info: book_info
                    }
                },
                receiversId: filterClassUsers,
            };

            if (classesForNotification.length > 0) {
                await createNotificationAssignment(payload, usersByClass);
                return;
            }
            await createCollectionNotification(payload, get(currentClass, 'id', ''));
        } catch (error) {
            console.log(error, "error")
        }
    }


    const deleteActivity = async (e) => {
        e.preventDefault();
        setDataLoading(true);
        const book_info = {
            locate_url: window.location.pathname + window.location.search,
            mask_id: maskId,
            page_cover_url: GrammarDrillCover,
        }
        const notificationData = {
            id: v4(),
            classId: get(currentClass, "id", ""),
            displayName: get(assignmentInfo, "displayName", ""),
            senderId: get(currentUser, 'id', ''),
            receiversId: filterClassUsers,
            modified: moment().toISOString(),
            data: {
                chapter: chapter,
                page: page,
                id: get(assignmentInfo, "id", ""),
                meta_data: {
                    book_info: book_info
                }
            },
            message: `Your teacher Delete this Assignment`,
            type: "delete_activity",
            userSeen: []
        };
        await dispatch(handledeleteDebate(assignmentInfo.session_id, currentClass.id))
        await fetchClassGameActivity()
        if (assignmentInfo && assignmentInfo.sAssignmentId && currentClass.sectionId) {
            await handleDeleteSchoologyAssignment(currentClass.sectionId, currentUser.schoologyid, assignmentInfo.sAssignmentId)
            listSchoologyAssignment(currentClass.sectionId)
        }
        if (currentClass.googleId && assignmentInfo.googleId) {
            await handleDeleteGoogleAssignment(currentUser.googleId, currentClass.googleId, assignmentInfo.googleId)
        }
        if (assignmentInfo && assignmentInfo.canvas_id) {
            try {
                await handleDeleteCanvasAssignment(currentUser.canvas_id, [{
                    canvas_id: assignmentInfo.canvas_id,
                    canvas_section_id: currentClass.canvas_id,
                    canvas_course_id: currentClass.canvas_course_id
                }], currentUser.canvas_auth_id);
            } catch (error) {

            }
        }
        onDeleteSuccess()
        sendNotifications(notificationData);
    };
    const onDeleteSuccess = () => {
        setdeleteClassAssignedActivityToggle(false);
        setDataLoading(false);
        setActivityDrawer(false);
    }

    const dateTimeSet = (key, value) => {
        try {
            let v = value.toISOString()
            setAssignmentData(e=>{
                return ({
                    ...e,
                    [key]: v
                })
            })
        } catch (error) {

        }
    }
    const onValueChange = (key, value)=>{
        setAssignmentData(e=>{
            return ({
                ...e,
                [key]: value
            })
        })
        if (key === "display_name" && onDisplayNameChange) {
            onDisplayNameChange(value);
        }
    }
    const getMinDate = (date1, date2) => {
        if (date1 && date2) {
            return isBeforTime(date1, date2) ? moment(date2).add(1, "minute").toISOString() : moment(date1).add(1, "minute").toISOString();
        } else if (date1 || date2) {
            return date1 ? moment(date1).add(1, "minute").toISOString() : moment(date2).add(1, "minute").toISOString();
        } else {
            return moment().toString()
        }
    }

    const hasSubmitbuttonDeactive = () => {
        if (!assignmentData.display_name||(typeof assignmentData.display_name  ==="string"&&assignmentData.display_name.replace(/\s/g,'').length==0)) return true;
        if (!assignmentData.dueDate) return true;
        if (isSchoologyUser && schoologyGradeCategory.length == 0) return true;
        else if (submissionLoading) return true;
        else if (moment(assignmentData.dueDate).isBefore(assignmentData.scheduleAt)) return true;
        else if (assignmentData.lateDate && moment(assignmentData.lateDate).isBefore(assignmentData.dueDate)) return true;
        else return false;
    }
    const getStartMintime = (value) => {
        if (isEditing && value) {
            return isBeforTime(moment(value).toISOString()) ? moment(value).toISOString() : moment().toISOString()
        } else {
            return moment().toISOString()
        }
    }
    const getDueMinDate = () => {
        if (!!initialDueDate) {
            return isBeforTime(initialDueDate) ? initialDueDate : moment();
        } else {
            return getMinDate(get(assignmentData, "scheduleAt"))
        }
    }

    const openDueDateAlert = () => {
        setAlert({
            open: true,
            message: `Assigning activities with due dates beyond the current semester is not possible.`
        })
    }
    const closeDueDateAlert = () => {
        setAlert({ open: false, message: '' })
    }
    const is_not_sync = () => {
        if (isEditing) {
            if (isSchoologyUser) {
                return !assignmentData.sAssignmentId
            } else if (isCanvas_user) {
                return !assignmentData.canvas_id
            } else if (isGoogleUser) {
                return !assignmentData.googleId
            } else {
                return false
            }
        } else {
            return assignmentData.no_sync
        }
    }
    const openAssignScreen = () =>{
        setActivityDrawer(true)
    }
    const closeAssignScreen = () =>{
        setAlreadyAssignedClassIds([])
        setAssignmentData((prev) => ({
            ...prev,
            classes: []
        }))
        setActivityDrawer(false)
    }
    const is_no_sync = is_not_sync()
    const hasGradeCatMissing = filter(assignmentData.classes, c => isSchoologyUser && !is_no_sync && !c.schoologyCategory)
    const hasGradeCatMissingForCanvas = filter(assignmentData.classes, c => isCanvas_user && !is_no_sync && !c.canvas_assignment_catrgory)
    const submitButtonDeactive = hasGradeCatMissing.length > 0 || hasSubmitbuttonDeactive() || hasGradeCatMissingForCanvas.length > 0
    return (
        <>
        {isEditing ? (<>
            <div
                        type="button cursor-pointer"
                        className={`iconLabel ${isTablate? "labelVisibleIconForSmallDeviceTablet" : "labelVisibleIconForSmallDevice"}`}
                        onClick={openAssignScreen}
                        style={{ display: "flex", alignItems: "center", gap: "8px" }}
                    >
                        {isEditing ? <img src={customEditSvg} alt="" title="" /> : null}
                        <label className={`cursor-pointer ${isTablate? "lablesNonVisibleOnSmallDeviceTablet" : "lablesNonVisibleOnSmallDevice"} `}> {isEditing?"Editar fechas":"Asignar"}</label>
                    </div>
        
        </>) : (
                        <button
                        type="button cursor-pointer"
                        className='asignarBtnCstm'
                        onClick={openAssignScreen}
                        style={{ display: "flex", alignItems: "center", gap: "8px" }}
                    >
                        {isEditing ? <img src={customEditSvg} alt="" title="" /> : null}
                        <label className='cursor-pointer'> {isEditing?"Editar fechas":"Asignar"}</label>
                    </button>
        )}

            <Snackbar
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                open={openAlert.open}
                autoHideDuration={3000}
                onClose={closeDueDateAlert}>
                <Alert onClose={closeDueDateAlert} severity="error">
                    <strong>ALERT:</strong> {openAlert.message}
                </Alert>
            </Snackbar>
            <Modal
                open={deleteClassAssignedActivityToggle}
                onClose={() => setdeleteClassAssignedActivityToggle(false)}
            >
                <ModalContent>
                    Are you sure you want to delete the assignment? All grades will be removed as well.
                    <ModalRow>
                        <Button
                            style={{ marginRight: '4px' }}
                            onClick={() => setdeleteClassAssignedActivityToggle(false)}
                        >
                            Cancel
                        </Button>
                        <Button
                            color="secondary"
                            variant="contained"
                            onClick={deleteActivity}
                            className={`${dataLoading ? "disabled" : ""}`}
                        >
                            {dataLoading ? <Loading size={20} white /> : 'Yes'}
                        </Button>
                    </ModalRow>
                </ModalContent>
            </Modal>
            <Drawer
                height='100%'
                destroyOnHidden
                className='assignments-drawer assignments-drawerCstm'
                onClose={closeAssignScreen}
                placement='top'
                open={activityDrawer}
                key='activityNew'
            >
                <SentryWrap>
                    <Wrapper onSubmit={onSubmit}>
                        <Row className='customImgContainRow' style={{ flexDirection: deviceType ? 'column' : 'row' }}>
                            <Col xs={24} sm={12} md={12} style={{ padding: "16px 10px", flex: deviceType ? 1 : 'unset', minWidth: deviceType ? '100%' : 'initial' }}>
                                <ImageContiner className='customImgContain'>
                                    {assignmentData.display_name ? <label className='customImgTitle'>{assignmentData.display_name}</label> : null}
                                    <Image src={GrammarDrillCover} alt='' />
                                </ImageContiner>
                            </Col>
                            <Col xs={24} sm={12} md={12} style={{ padding: "16px 16px", flex: deviceType ? 1 : 'unset', minWidth: deviceType ? '100%' : 'initial' }}>
                                <Header>{isEditing ? 'Edit Activity' : 'Assign Activity'}</Header>
                                <Description>Please, remember the activity due date is to create a logic that will automatically make the activity disappear from the student dashboard. If you want to make it visible after this date, you can go back and edit the details.</Description>
                                <Row gutter={[16, 24]}>
                                    <Col span={24}>
                                        <Acent inputRef={dispNameRef} setValue={(v) => onValueChange("display_name", v)} style={{ marginBottom: 5, display: "flex", justifyContent: "flex-end" }} />
                                        <TextField
                                            id="displayName"
                                            name="displayName"
                                            label="Display Name"
                                            InputLabelProps={{ shrink: true, required: true }}
                                            type="text"
                                            required
                                            variant="outlined"
                                            onChange={e => {
                                                onValueChange("display_name", e.target.value)
                                            }}
                                            value={assignmentData.display_name}
                                        />
                                    </Col>
                                </Row>
                                <Row gutter={[16, 24]} className="durDateSpc">
                                    <Col span={24}>
                                        <CustomDateTimePicker
                                            id="scheduleAt"
                                            label="Start date"
                                            inputVariant="outlined"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            format="MM-dd-yyyy hh:mm a"
                                            //  disabled={((checkAssignmentHaveSubmission && isEditing) || (currentUser?.googleId) || (currentUser?.schoologyid)) ? true : false}
                                            disabled = {checkAssignmentHaveSubmission && isEditing ? true : false}
                                            minDateMessage={`Start date and time has to be after the ${moment(getStartMintime(get(assignmentData, "scheduleAt"))).format("MM-DD-YYYY hh:mm a")} `}
                                            defaultValue={null}
                                            initialFocusedDate={moment().toString()}
                                            value={get(assignmentData, "scheduleAt")}
                                            onChange={e => {
                                                dateTimeSet("scheduleAt", e)
                                            }} />
                                    </Col>
                                    <div className=' flex items-start'>
                                    <Tag height={20}><Star style={{ height: '12px', width: '12px' }} /> NOTE</Tag>
                                        <Note>The assignment will take effect after the scheduled date and time.</Note>
                                    </div>
                                </Row>
                                <Row gutter={[16, 24]} className="durDateSpc">
                                    <Col span={24}>
                                        <CustomDateTimePicker
                                            id="dueDate"
                                            label="Due Date"
                                            inputVariant="outlined"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            format="MM-dd-yyyy hh:mm a"
                                            minDate={getDueMinDate()}
                                            initialFocusedDate={moment().toString()}
                                            strictCompareDates
                                            //minDateMessage={"Due Date and Time has to be after the Start Date and Time."}
                                            defaultValue={null}
                                            value={get(assignmentData, "dueDate")}
                                            onChange={e => {
                                                if (!isBeforTime(e, currentSemDateAndTime.start) && !isAfterTime(e, currentSemDateAndTime.end)) {
                                                    dateTimeSet("dueDate", e)
                                                    setInitialLateDate(null)
                                                } else {
                                                    openDueDateAlert()
                                                }
                                            }} />
                                    </Col>
                                    <div className='flex items-start '>
                                        <Tag height={20}><Star style={{ height: '12px', width: '12px' }} /> NOTE</Tag>
                                        <Note>Due at midnight from the chosen date.</Note>
                                    </div>
                                </Row>
                                {/* Shuffle start */}
                                <Container className='asignActivityUpr'>
                                    <Row justify="start" style={{ marginBottom: 10 }}>
                                        <StyledFormControlLabel
                                            className="rootDif"
                                            control={
                                                <StyledSwitch
                                                    checked={assignmentData.shuffled}
                                                    disabled={isEditing}
                                                    id="shuffled"
                                                    onChange={e => {
                                                        onValueChange('shuffled', e.target.checked)
                                                    }}
                                                    name="shuffled"
                                                    color="primary"
                                                    size="small"
                                                />
                                            }
                                            label={<StyledLabel>Shuffle</StyledLabel>}
                                        />
                                    </Row>
                                    <div style={{ display: 'flex', alignItems: 'start', justifyContent: 'flex-start', marginTop: 14,marginBottom:35 }}>
                                        <Tag height={20}><Star style={{ height: '12px', width: '12px' }} /> NOTE</Tag>
                                        <Note style={{marginBottom:0}}>Questions will be rearranged on a per-student basis.</Note>
                                    </div>
                                </Container>
                                {/* Shuffle End */}
                                <Container>
                                    <WorksheetAssignmentClassConfig
                                        userClasses={userClasses}
                                        data={assignmentData}
                                        handleChange={(v) =>{
                                            if(v&&v.target){
                                                onValueChange(v.target.id, v.target.value)
                                            }
                                        }}
                                        isSchoologyUser={isSchoologyUser}
                                        schoologyAllClassGradeCategory={schoologyAllClassGradeCategory}
                                        chapter={chapter}
                                        isEditing={isEditing}
                                        alreadyAssignedClassIds={alreadyAssignedClassIds}
                                    />
                                </Container>
                                <Container>
                                    <Row gutter={[16, 24]}>
                                        <Col span={16}>
                                            <Tag height={20}><Star style={{ height: '12px', margin: '-1px 4px 0px 0px', width: '12px' }} /> Weightage</Tag>
                                            <Note style={{ marginBottom: 0 }}>This weightage is used to calculate grade.</Note>
                                            <Note style={{ color: COLOR.red, fontSize: 10 }}>You will not be able to edit the weightage after assigning activity or quiz.</Note>
                                        </Col>
                                        <Col span={8}>
                                            {((!isSchoologyUser && !isCanvas_user) || is_no_sync) && !assignmentData.ungraded ?
                                                <TextField
                                                    id="weightage"
                                                    disabled={isEditing}
                                                    onChange={(e) => {
                                                        let val = e.target.value
                                                        val = val > 100 ? assignmentData?.weightage : val
                                                        onValueChange("weightage", val)
                                                    }}
                                                    variant="outlined"
                                                    defaultValue={100}
                                                    value={parseInt(assignmentData?.weightage ?? 100, 10)}
                                                    type="number"
                                                    InputProps={{
                                                        inputProps: {
                                                            min: 0,
                                                            max: 100
                                                        }
                                                    }}
                                                /> : null}
                                            {(!isSchoologyUser && !isCanvas_user) || is_no_sync ? <StyledFormControlLabel
                                                control={
                                                    <StyledCheckbox
                                                        checked={assignmentData.ungraded}
                                                        id="ungraded"
                                                        onChange={e => {
                                                            onValueChange("ungraded", e.target.checked)
                                                        }}
                                                        name="ungraded"
                                                        color="primary"
                                                        size="small"
                                                    />
                                                }
                                                label="Ungraded"
                                            /> : null}
                                        </Col>
                                    </Row>
                                    {(!isSchoologyUser || is_no_sync) && <Row gutter={[16, 24]}>
                                        <Col span={8}>
                                            <StyledFormControl size="small" variant="outlined">
                                                <StyledInputLabel id="grade_type" style={{ backgroundColor: "#fff", width: 'max-content' }}>Display Grade as</StyledInputLabel>
                                                <StyledSelect
                                                    labelId="grade_type"
                                                    disabled={isEditing}
                                                    value={get(find(isCanvas_user ? GRADE_TYPE_CANVAS : GRADE_TYPE_ALL, ["value", assignmentData.grade_type]), "type", "Percentage")}
                                                    onChange={e => {
                                                        onValueChange("grade_type", e.target.value)
                                                    }}
                                                    renderValue={(selected) => (
                                                        <div>
                                                            <StyledListItemText primary={selected} />
                                                        </div>
                                                    )}
                                                    MenuProps={MenuProps}
                                                >
                                                    {map(isCanvas_user ? GRADE_TYPE_CANVAS : GRADE_TYPE_ALL, (option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                            <ListItemText primary={`${option.type}`} />
                                                        </MenuItem>
                                                    ))}
                                                </StyledSelect>
                                            </StyledFormControl>
                                        </Col>
                                        <Col span={4} style={{ justifyContent: "center", alignItems: "center", display: "flex" }}>
                                            {assignmentData.grade_type === 'points' ? <TextField
                                                id="max_point"
                                                defaultValue={100}
                                                disabled={assignmentData.editing}
                                                onChange={(e) => {
                                                    onValueChange("max_point", e.target.value)
                                                }}
                                                variant="outlined"
                                                value={assignmentData.max_point}
                                                className={"max_point"}
                                                type="number"
                                                InputProps={{
                                                    inputProps: {
                                                        min: 0
                                                    }
                                                }}
                                                style={{ height: 50 }}
                                            /> : null}

                                        </Col>
                                    </Row>}
                                    <Row justify="start" style={{ marginBottom: 10 }}>
                                        <StyledFormControl
                                            variant="outlined"
                                            size="small"
                                            className="dropdownSwitch"
                                            disabled={isEditing}
                                        >
                                            <StyledInputLabel
                                                id="grade-for-participation-label"
                                            >
                                                Grading Mode
                                            </StyledInputLabel>
                                            <StyledSelect
                                                labelId="grade-for-participation-label"
                                                id="grade_for_participation"
                                                value={assignmentData.grade_for_participation ? 'participation' : 'submission'}
                                                onChange={e =>
                                                    onValueChange(
                                                        'grade_for_participation',
                                                        e.target.value === 'participation'
                                                    )
                                                }
                                                label="Grading Mode"
                                            >
                                                <MenuItem value="submission">Grade for submission</MenuItem>
                                                <MenuItem value="participation">Grade for participation</MenuItem>
                                            </StyledSelect>
                                        </StyledFormControl>
                                    </Row>
                                </Container>

                                {isSchoologyUser && hasGradeCatMissing.length > 0 ? <Note style={{ marginBottom: 0, color: COLOR.radish100 }}>Weightage category is required for {`${hasGradeCatMissing.map(k => k.displayName).join(',')}`}</Note> : null}
                                {isCanvas_user && hasGradeCatMissingForCanvas.length > 0 ? <Note style={{ marginBottom: 0, color: COLOR.radish100 }}>Assignment category is required for {`${hasGradeCatMissingForCanvas.map(k => k.displayName).join(',')}`}</Note> : null}
                                <Row justify="space-between" style={{ marginBottom: 16 }} className='assigmentLstSec'>
                                    <Col sm={24} xs={24} md={10} lg={10} xl={10} xxl={10} style={{ display: "flex", gap: 10, alignItems: "flex-end" }} >
                                        {(isEditing) && <Button
                                            className='assigmentLstDelete'
                                            color="secondary"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                setdeleteClassAssignedActivityToggle(true)
                                            }}
                                            variant="contained"
                                            style={{ padding: '0px 0px !important', height: 30, width: 60 }}
                                        >
                                            <Delete style={{ fontSize: '16px', width: '16px' }} />
                                        </Button>}
                                    </Col>
                                    <Col sm={24} xs={24} md={14} lg={14} xl={14} xxl={14} style={{ display: "flex", alignItems: "flex-end", flexDirection: "column" }} >
                                        <Button
                                            disabled={submitButtonDeactive}
                                            variant="contained"
                                            color="primary"
                                            type='submit'
                                            className='updateActvityBtn'
                                            endIcon={<ArrowForward style={{ height: '18px', margin: '0px 0px 0px 6px', width: '18px' }} />}
                                        >
                                            {isEditing ? ((submissionLoading) ? <Loading size={20} white /> : 'Update Activity') : ((submissionLoading) ? <Loading size={20} white /> : 'Assign Activity')}
                                        </Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Wrapper>
                </SentryWrap>
            </Drawer>


        </>);
};





export default memo(ActivityFormWorksheet);